<div>
  <eds-link-item [title]="cellvalue" [href]="link"></eds-link-item>
</div>
